import { request } from '@remote/api/request'

/**
 * 流量查询
 */
export const getFlowInfo = async () => {
  return request('/flow/v1/about', {
    params: {
      scene: 'DownloadUrl',
    },
    method: 'GET',
  })
}